import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { LocalizationContext } from '@cvt/contexts';


const MESSAGE_MAX_LENGTH = 2000;

export type SupportContactFormValues = {
  message: string;
};

interface Props {
  onSubmitRequest: (values: SupportContactFormValues) => Promise<void> | void;
  onCancel: () => void;
}

export const SupportContactForm: React.FC<Props> = ({ onSubmitRequest, onCancel }) => {

  const { dictionary } = React.useContext(LocalizationContext);

  const { handleSubmit, control, formState: { isSubmitting, errors } } = useForm<SupportContactFormValues>({
    defaultValues: { message: '' },
  });

  return (
    <form onSubmit={handleSubmit(onSubmitRequest)}>
      <DialogContent sx={{ pt: 0 }}>
        <DialogContentText sx={{ mb: 2 }}>
          {dictionary.users.supportContact.dialog.subtitle}
        </DialogContentText>
        <Controller
          name="message"
          control={control}
          rules={{
            required: dictionary.forms.validations.required,
            maxLength: {
              value: MESSAGE_MAX_LENGTH,
              message: dictionary.forms.validations.maxLength(MESSAGE_MAX_LENGTH),
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              fullWidth
              autoFocus
              multiline
              minRows={5}
              placeholder={dictionary.users.supportContact.dialog.placeholderMessage}
              slotProps={{
                htmlInput: {
                  maxLength: MESSAGE_MAX_LENGTH,
                  'aria-label': dictionary.users.supportContact.dialog.placeholderMessage,
                },
              }}
              error={!!errors.message}
              helperText={errors.message?.message}
              sx={{ '& .MuiOutlinedInput-root': { height: 'auto' } }}
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button type="button" variant="text" onClick={onCancel}>{dictionary.dialogs.buttonCancel}</Button>
        <LoadingButton type="submit" loading={isSubmitting} variant="contained">
          {dictionary.users.supportContact.dialog.buttonSend}
        </LoadingButton>
      </DialogActions>
    </form>
  );
};
